import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/AuthContext";

function AdminCreateSub() {
  const { createSubAdmin } = useAuth();

  const [formData, setFormData] = useState({
    firstname: "",
    secondname: "",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    designation: "",
    location: "",
    commission_percentage: "",
    termsAccepted: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [apiErrors, setApiErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    setFieldErrors((prev) => ({ ...prev, [name]: false }));
    setApiErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.firstname.trim()) errors.firstname = "First name is required";
    if (!formData.secondname.trim()) errors.secondname = "Second name is required";

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Invalid email";
    }

    if (!formData.password || formData.password.length < 5)
      errors.password = "Password must be at least 5 characters";

    if (formData.password !== formData.confirmPassword)
      errors.confirmPassword = "Passwords do not match";

    if (!formData.address.trim()) errors.address = "Address required";
    if (!formData.designation.trim()) errors.designation = "Designation required";
    if (!formData.location.trim()) errors.location = "Location required";

    if (!formData.commission_percentage) {
      errors.commission_percentage = "Commission is required";
    }

    if (!formData.termsAccepted) {
      errors.termsAccepted = "Accept terms & conditions";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);

    const payload = {
      first_name: formData.firstname,
      last_name: formData.secondname,
      email: formData.email,
      password: formData.password,
      confirm_password: formData.confirmPassword,
      commission_percentage: Number(formData.commission_percentage),
      address: formData.address,
      designation: formData.designation,
      location: formData.location,
    };

    const result = await createSubAdmin(payload);

    if (result.success) {
      toast.success("Sub-admin created successfully!");
      setFormData({
        firstname: "",
        secondname: "",
        email: "",
        password: "",
        confirmPassword: "",
        address: "",
        designation: "",
        location: "",
        commission_percentage: "",
        termsAccepted: false,
      });
    } else {
      toast.error(result.message || "Failed to create sub-admin");
    }

    setIsLoading(false);
  };

  return (
    <div className="flex justify-center items-center mt-5">
      <ToastContainer />
      <div className="bg-gray-100 rounded-lg shadow-lg p-8 w-full">
        <h2 className="text-2xl font-bold text-center mb-6">
          Create Sub-Admin
        </h2>

        <form onSubmit={handleRegister} className="grid md:grid-cols-2 gap-6">
          <input name="firstname" placeholder="First Name" value={formData.firstname} onChange={handleInputChange} className="input" />
          <input name="secondname" placeholder="Second Name" value={formData.secondname} onChange={handleInputChange} className="input" />
          <input name="email" placeholder="Email" value={formData.email} onChange={handleInputChange} className="input" />
          <input name="address" placeholder="Address" value={formData.address} onChange={handleInputChange} className="input" />
          <input name="designation" placeholder="Designation" value={formData.designation} onChange={handleInputChange} className="input" />
          <input name="location" placeholder="Location" value={formData.location} onChange={handleInputChange} className="input" />

          <input
            name="commission_percentage"
            type="number"
            placeholder="Commission %"
            value={formData.commission_percentage}
            onChange={handleInputChange}
            className="input"
          />

          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleInputChange}
              className="input"
            />
            <span onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-3 cursor-pointer">
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              className="input"
            />
            <span onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-3 top-3 cursor-pointer">
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="col-span-2 flex items-center gap-2">
            <input type="checkbox" name="termsAccepted" checked={formData.termsAccepted} onChange={handleInputChange} />
            <span>I agree to terms & conditions</span>
          </div>

          <button disabled={isLoading} className="col-span-2 bg-green-600 text-white py-2 rounded">
            {isLoading ? "Creating..." : "Create Sub-Admin"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminCreateSub;
